import "./Hero.css";
import { motion, useReducedMotion } from "framer-motion";
import QrCorners from "./QrCorners";

const containerVariants = {
  hidden: {},
  show: {
    transition: { staggerChildren: 0.09, delayChildren: 0.05 },
  },
};

const itemVariants = {
  hidden: { opacity: 0, y: 18 },
  show: { opacity: 1, y: 0, transition: { duration: 0.55, ease: [0.16, 1, 0.3, 1] } },
};

function Hero() {
  const prefersReducedMotion = useReducedMotion();

  return (
    <section className="landing-hero">
      <div className="landing-container landing-hero-inner">
        <motion.div
          className="landing-hero-content"
          variants={prefersReducedMotion ? undefined : containerVariants}
          initial={prefersReducedMotion ? false : "hidden"}
          animate={prefersReducedMotion ? undefined : "show"}
        >
          <motion.span
            className="landing-eyebrow landing-hero-eyebrow"
            variants={prefersReducedMotion ? undefined : itemVariants}
          >
            Beolvasás → Rendelés → Konyha
          </motion.span>

          <motion.h1 variants={prefersReducedMotion ? undefined : itemVariants}>
            Digitális étlap, QR-rendelés
            <br />
            <span>és teljes éttermi irányítás</span>
            <br />
            egyetlen rendszerben
          </motion.h1>

          <motion.p variants={prefersReducedMotion ? undefined : itemVariants}>
            Kezeld az étlapot, a rendeléseket, az asztalokat és a bevételeidet
            egy helyen — a QR-kódos rendeléstől a valós idejű statisztikákig.
          </motion.p>

          <motion.div
            className="landing-hero-buttons"
            variants={prefersReducedMotion ? undefined : itemVariants}
          >
            <a
              href="https://app.tablify.hu/register"
              className="landing-btn-primary"
            >
              Ingyenes Kipróbálás
            </a>

            <a
              href="https://teszt-etterem.tablify.hu"
              className="landing-btn-secondary"
            >
              Élő Demó
            </a>
          </motion.div>

          <motion.div
            className="landing-badges"
            variants={prefersReducedMotion ? undefined : itemVariants}
          >
            <div className="landing-badge">Nincs App Letöltés</div>
            <div className="landing-badge">2 Perc Setup</div>
            <div className="landing-badge">Mobilbarát</div>
          </motion.div>
        </motion.div>

        <motion.div
          className="landing-hero-image"
          initial={prefersReducedMotion ? false : { opacity: 0, y: 24, scale: 0.96 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1], delay: 0.2 }}
        >
          <div className="phone-wrap">
            <div className="phone-glow" aria-hidden="true" />
            <div className="phone">
              <div className="phone-screen">
                <video
                  className="phone-video"
                  autoPlay
                  loop
                  muted
                  playsInline
                >
                  <source src="/static/images/tablify-demo.mp4" type="video/mp4" />
                </video>
              </div>
            </div>
            <QrCorners tone="gold" />
          </div>
        </motion.div>
      </div>
    </section>
  );
}

export default Hero;
